<template>
    <div class="k-star">
        <div class="star-percent">
            <span class="back">
                <i class="star outline"></i>
                <i class="star outline"></i>
                <i class="star outline"></i>
                <i class="star outline"></i>
                <i class="star outline"></i>
            </span>
            <span class="front" :style="{width: width}">
                <i class="star fill"></i>
                <i class="star fill"></i>
                <i class="star fill"></i>
                <i class="star fill"></i>
                <i class="star fill"></i>
            </span>
        </div>
        {{star.toFixed(1)}}
    </div>
</template>

<style lang="less" scoped>
.k-star {
    display: inline-block;
    .star-percent {
        display: inline-block;
        position: relative;
        overflow: hidden;
        vertical-align: middle;
    }
    .front {
        position: absolute;
        top: 0; left: 0;
        height: 100%;
        white-space: nowrap;
        overflow: hidden;
    }
    // font-size: inherit;
    .star {
        display: inline-block;
        margin: 0 0.1em;
        width: 1em;
        height: 1em;
        font-size: inherit;
        background: url("../../assets/img/star-outline.svg") center/100% 100% no-repeat;
        &.fill {
            background: url("../../assets/img/star-fill.svg") center/100% 100% no-repeat;
        }
    }
}
</style>

<script>
export default {
    name: 'k-star',
    props: {
        star: Number
    },
    computed: {
        width() {
            const i = Math.floor(this.star);
            const d = this.star - i;
            return (i * 0.2 + (d*10/12 + 1/12) * 0.2) * 100 + '%';
        }
    }
}
</script>
